module.exports = __webpack_public_path__ + "static/media/do.4cf354aa.svg";